import React, { useEffect } from 'react';
import { useScriptLoader } from 'Src/hooks/use-script-loader/useScriptLoader';
import { useAppContext } from 'Context/ReactAppContext';
import config from 'Config/index';
import { classnames } from 'Utils/classnames/classnames.utils';

export const PaypalForm = ({ isAbleToPay, onSuccess, amount }) => {
  const { scriptLoaded } = useScriptLoader(config.get('psp.mhipay.script_url'));

  const { locale, currency } = useAppContext();

  useEffect(() => {
    if (scriptLoaded) {
      // eslint-disable-next-line new-cap
      const hipay = window.HiPay({
        environment: config.get('psp.mhipay.environment'),
        password: config.get('psp.mhipay.password'),
        username: config.get('psp.mhipay.username'),
      });
      const instancePayPal = hipay.create('paypal', {
        canPayLater: false,
        request: {
          amount,
          currency,
          locale: locale.replace('-', '_'),
        },
        paypalButtonStyle: { shape: 'pill', color: 'gold', height: 45 },
        template: 'auto',
        selector: 'paypal-button',
      });

      instancePayPal.on('paymentAuthorized', function (data) {
        onSuccess(data.orderID);
      });
    }
  }, [scriptLoaded]);

  return (
    <div
      id="paypal-button"
      className={classnames('h-45', {
        hidden: !isAbleToPay,
      })}
    ></div>
  );
};
